require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-44-organize-your-projects.json") })
        }
      }, "path---article-44-organize-your-projects");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-44-organize-your-projects!./.cache/json/article-44-organize-your-projects.json
// module id = 549
// module chunks = 231608221292675